import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-stone-50">
      {/* Navbar */}
      <nav className="w-full px-6 py-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-stone-800 tracking-tight">ProLog</h1>
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="px-4 py-2 text-sm font-medium text-stone-700 hover:text-stone-900 transition-colors whitespace-nowrap"
          >
            Giriş Yap
          </Link>
          <Link
            to="/register"
            className="px-4 py-2 text-sm font-medium bg-stone-800 text-white rounded-lg hover:bg-stone-900 transition-colors whitespace-nowrap"
          >
            Kayıt Ol
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <main className="flex flex-col items-center justify-center px-4 pt-20 pb-32 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-stone-800 max-w-2xl leading-tight">
          Projelerinizi Tek Bir Yerden Yönetin
        </h2>
        <p className="mt-6 text-lg text-stone-500 max-w-lg">
          Görevler, listeler, dosyalar ve çizimler — hepsi ProLog'da. 
          Freelancerlar ve küçük ekipler için tasarlandı.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <Link
            to="/register"
            className="px-8 py-3 bg-stone-800 text-white rounded-lg text-sm font-medium hover:bg-stone-900 transition-colors whitespace-nowrap"
          >
            Ücretsiz Başla
          </Link>
          <Link
            to="/login"
            className="px-8 py-3 border border-stone-300 text-stone-700 rounded-lg text-sm font-medium hover:bg-stone-100 transition-colors whitespace-nowrap"
          >
            Giriş Yap
          </Link>
        </div>

        {/* Features */}
        <div className="mt-24 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl w-full">
          <div className="bg-white rounded-xl p-6 border border-stone-200">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
              <i className="ri-list-check text-amber-600 text-lg"></i>
            </div>
            <h3 className="font-semibold text-stone-800 text-sm">Listeler & Notlar</h3>
            <p className="mt-2 text-stone-500 text-sm">Kalemlere not ekleyin, tamamlananları işaretleyin.</p>
          </div>
          <div className="bg-white rounded-xl p-6 border border-stone-200">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
              <i className="ri-task-line text-amber-600 text-lg"></i>
            </div>
            <h3 className="font-semibold text-stone-800 text-sm">Görev Yönetimi</h3>
            <p className="mt-2 text-stone-500 text-sm">Görevlere atama yapın, tarih belirleyin, takip edin.</p>
          </div>
          <div className="bg-white rounded-xl p-6 border border-stone-200">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
              <i className="ri-image-line text-amber-600 text-lg"></i>
            </div>
            <h3 className="font-semibold text-stone-800 text-sm">Dosya & Çizim</h3>
            <p className="mt-2 text-stone-500 text-sm">Dosya, resim yükleyin ve canvas üzerinde çizin.</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full py-6 text-center text-stone-400 text-sm border-t border-stone-200">
        ProLog — Proje takip uygulaması
      </footer>
    </div>
  );
}